import { Chip, styled } from '@mui/material';

import { colorPrimary } from '../../../../../styles/mui/colors';

export const StyledChip = styled(Chip)(() => ({
  '& > .MuiChip-label': {
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 'var(--preference-button-line-clamp)',
    display: '-webkit-box',
    fontWeight: 'var(--font-medium)',
    lineClamp: 'var(--preference-button-line-clamp)',
    overflow: 'hidden',
    textWrap: 'wrap',
    wordBreak: 'break-all',
  },
  '& > .MuiSvgIcon-root': {
    color: 'inherit',
  },
  '&:focus': {
    backgroundColor: colorPrimary[200],
    border: 'var(--border-alternative)',
  },
  '&:hover': {
    backgroundColor: colorPrimary[100],
  },
  backgroundColor: colorPrimary[50],
  borderRadius: 'var(--border-radius-small)',
  color: 'var(--color-blue-darker)',
}));

export const StyledList = styled('ul')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'var(--spacing-tiny)',
  justifyContent: 'flex-start',
}));

export const StyledListItem = styled('li')(() => ({
  maxWidth: 'var(--preference-compose-assignment-item-width)',
}));
